import { Component} from '@angular/core';

@Component({
    selector: 'collection-builder-main',
    templateUrl: './collection-builder-main.tmpl.html'
})

export class CollectionBuilderMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  